import AuthRepository from '@lib/api/repository/auth/auth.repository';
import AuthUseCase from '@lib/interfaces/usecase/auth.use-case';
import { Account } from '@lib/types';

class AuthService implements AuthUseCase {
  constructor(private readonly repository: AuthRepository) {}

  async login(username: string, password: string): Promise<Account> {
    return this.repository.login(username, password);
  }

  findAccount(signal?: AbortSignal): Promise<Account | null> {
    return this.repository.findProfile(signal);
  }

  forgotPassword(recoveryEmail: string): Promise<void> {
    return this.repository.forgotPassword(recoveryEmail);
  }

  resetPassword(code: string, newPassword: string): Promise<void> {
    return this.repository.resetPassword(code, newPassword);
  }

  async logout(): Promise<void> {
    await this.repository.logout();
  }
}

export default AuthService;
